import React, { useState, useEffect, useCallback } from 'react'
import _ from 'lodash.get'

import { categories as CategoriesAPI } from 'api'
import { useSelector } from 'react-redux'

const api = CategoriesAPI.records

const usePluginLabels = ({ user }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [inRequest, setInRequest] = useState(true)
  // const [inRequestAll, setInRequestAll] = useState(false)
  const [currentUser, setCurrentUser] = useState(null)
  const [categories, setCategories] = useState([])
  const [allCategories, setAllCategories] = useState([])
  const categoryEvent = useSelector(state => state.categories)
  const activeUser = useSelector(state => state?.tabs?.activeUser)
  const subjectId = useSelector(state => state.conversations[user.id].composer.currentSubject?._id)
  const [currentSubject, setCurrentSubject] = React.useState(subjectId)
  const [isOpenModalIsFolder, setIsOpenModalIsFolder] = useState(false)

  //EJECUTA DESDE EL SOCKET
  useEffect(() => {
    if (categoryEvent?.category?.userId === activeUser) {
      getCategoriesList()
    }
  }, [categoryEvent])

  useEffect(() => {
    document.addEventListener("keydown", close, false)
    return () => {
      document.removeEventListener("keydown", close, false)
    }
  }, [])

  useEffect(() => {
    if (currentSubject !== subjectId) {
      setCategories([])
      getCategoriesList()
      setCurrentSubject(subjectId)
      setIsOpen(false)
    } else if (!subjectId) {
      setCategories([])
      setIsOpen(false)
    }
  }, [subjectId])

  useEffect(() => {
    if (currentUser && currentUser._id !== user._id) {
      setCurrentUser(user)
      setCategories([])
      setIsOpen(false)
      getCategoriesList()
    } else if (!currentUser) {
      setCurrentUser(user)
      getCategoriesList()
      setIsOpen(false)
    }
  }, [user])

  useEffect(() => {
    if (isOpen) getAllCategories(categories)
  }, [isOpen])

  const getTypeAndId = () => {
    const type = _(user, 'channels.0.provider', null) === 'chatmail' && subjectId ? 'subject' : 'user'

    let id
    if (type === 'subject') {
      id = subjectId
    } else {
      let { _id } = user
      id = _id
    }
    return { type, id }
  }

  const close = useCallback((event) => {
    if (event.key === "Escape") setIsOpen(false)
  }, [])

  const getCategoriesList = () => {
    const { type, id } = getTypeAndId()
    setInRequest(true)
    if (id) {
      api.list(type, id)
        .then(({ data: categories }) => {
          setCategories(categories)
          setAllCategories([])
          setInRequest(false)
        })
        .catch((error) => {
          console.error(error)
          setInRequest(false)
        })
    } else setInRequest(false)
  }

  const getAllCategories = async (_categories) => {
    try {
      setIsLoading(true)
      const brands = [user.brand]
      const delegations = [user.delegation]
      const searchedCategories = await api.search(brands, delegations)
      const { data } = searchedCategories
      let withCheck = data.map(category => {
        const exists = _categories.find(e => e.category === category.category)
        if (exists) {
          category.added = true
        }
        return category
      })
      setAllCategories(withCheck)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  const addRecord = (category) => {
    if (!category.added) {
      const { id } = user
      const { type, id: typeId } = getTypeAndId()

      api.add(id, type, typeId, category.category)
        .then(() => {
          getCategoriesList()
          setIsOpen(false)
        })
        .catch(console.error)
    }
  }

  const removeRecord = (category) => {
    const { id } = user
    const { type, id: typeId } = getTypeAndId()

    setIsOpen(false)
    api.remove(id, type, typeId, category.category)
      .then(() => {
        getCategoriesList()
        setAllCategories([])
      })
      .catch(console.error)
  }

  const debounce = (func, delay) => {
    let timeoutId
    return function(...args) {
      const context = this
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => func.apply(context, args), delay)
    }
  }


  const searchCategory = debounce((name) => {
    // setInRequestAll(true)
    if (name.length) {
      const brands = [user.brand]
      const delegations = [user.delegation]

      api.search(brands, delegations, name)
        .then(({ data }) => {
          let withCheck = data.map(category => {
            const exists = categories.find(e => e.category === category.category)
            if (exists) {
              category.added = true
            }
            return category
          })
          setAllCategories(withCheck)
          // setInRequestAll(false)
        })
        .catch(console.error)
    } else {
      getAllCategories(categories)
      // setInRequestAll(false)
    }
  }, 300)

  return {
    isOpenModalIsFolder, setIsOpenModalIsFolder, isOpen, isLoading,
    setIsOpen, inRequest, categories, allCategories, addRecord,
    removeRecord, searchCategory, subjectId, getTypeAndId,
  }
}

export default usePluginLabels
